import psHttp from '@patsnap/common-ps-http';
import { workspaceApiUrlPrefix } from '@cores/constants/envConfig';
let defPsHttp = psHttp;
export function overwritePsHttp(psHttp) {
    defPsHttp = psHttp;
}
/**
 * 更新文件夹，开启扩展同族
 * @param {*} param0
 */
export function updateFolderApi({ space_id, folder_id, folder_name, folder_desc, folder_expansion, expansion_family }) {
    return defPsHttp({
        url: `${workspaceApiUrlPrefix}/${space_id}/folder/${folder_id}`,
        method: 'POST',
        data: {
            folder_name,
            folder_desc,
            folder_expansion,
            expansion_family,
        },
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}
/**
 * 查询所有Folder list
 * @param {*} space_id
 */
export function getFolderListApi({ space_id }) {
    return defPsHttp({
        url: `${workspaceApiUrlPrefix}/space/${space_id}/folder-list`,
        method: 'GET',
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}
/**
 * 创建文件夹
 */
export function createFolderApi({ space_id, parent_id, folder_name, folder_desc, cal_folder_ids, cal_merge_type, folder_auto_update, update_type, }) {
    return defPsHttp({
        url: `${workspaceApiUrlPrefix}/space/${space_id}/folder`,
        method: 'PUT',
        data: {
            parent_id,
            folder_name,
            folder_desc,
            cal_folder_ids,
            cal_merge_type,
            folder_auto_update,
            update_type,
        },
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}
/**
 * 获取计算文件夹数量
 */
export function getFolderMergeCountApi({ space_id, folder_ids, merge_type, }) {
    return defPsHttp({
        url: `${workspaceApiUrlPrefix}/space/${space_id}/folder/merge-count`,
        method: 'POST',
        data: {
            space_id,
            folder_ids,
            merge_type,
        },
        transformCode: true,
    }).then(({ data }) => {
        return data.data || 0;
    });
}
/**
 * 移动文件夹
 */
export function moveFolderApi({ folder_id, parent_folder, to_space, copy_field_comment_request }) {
    return defPsHttp({
        url: `${workspaceApiUrlPrefix}/folder/${folder_id}/move-folder`,
        method: 'POST',
        data: {
            parent_folder,
            to_space,
            copy_field_comment_request,
        },
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}
/**
 * 批量移动文件夹
 */
export function batchMoveFolderApi({ space_id, folder_ids, parent_folder, to_space, copy_field_comment_request }) {
    return defPsHttp({
        url: `${workspaceApiUrlPrefix}/space/${space_id}/folder/batch-move-folder`,
        method: 'POST',
        data: {
            folder_ids,
            parent_folder,
            to_space,
            copy_field_comment_request,
        },
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}
/**
 * 拖拽文件夹
 * @param {*} param0
 */
export function dragFolderApi({ space_id, folder_id, parent_folder_id, sort }) {
    return defPsHttp({
        url: `${workspaceApiUrlPrefix}/space/${space_id}/folder/${folder_id}/drag-folder`,
        method: 'POST',
        data: {
            parent_folder_id,
            sort,
        },
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}
/**
 * 删除文件夹
 */
export function deleteFolderApi({ space_id, folder_id }) {
    return defPsHttp({
        url: `${workspaceApiUrlPrefix}/space/${space_id}/folder/${folder_id}`,
        method: 'DELETE',
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}
/**
 * 批量删除文件夹
 */
export function batchDeleteFolderApi({ space_id, folder_ids }) {
    return defPsHttp({
        url: `${workspaceApiUrlPrefix}/space/${space_id}/batch-delete-folder`,
        method: 'DELETE',
        data: folder_ids,
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}
/**
 * 快速保存
 */
export function quickSavePatentsApi({ patent_ids = [] }) {
    return defPsHttp({
        url: `${workspaceApiUrlPrefix}/quick`,
        method: 'PUT',
        data: patent_ids,
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}
/**
 * 快速保存带有bio_uk
 */
export function quickSaveEnhanceApi({ patent_ids = [], bio_uk = [], from_space_id, from_folder_id }) {
    return defPsHttp({
        url: `${workspaceApiUrlPrefix}/patent/quick_enhance`,
        method: 'PUT',
        data: {
            patent_ids,
            bio_uk,
            from_space_id,
            from_folder_id,
        },
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}
/**
 * 取消快速保存
 */
export function deleteQuickSavePatentsApi({ folder_id, patent_id }) {
    return defPsHttp({
        url: `${workspaceApiUrlPrefix}/folder/${folder_id}/patent/${patent_id}`,
        method: 'DELETE',
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}
/**
 * 查询快速保存
 */
export function quickSaveStatusApi({ patent_ids = [] }) {
    return defPsHttp({
        url: `${workspaceApiUrlPrefix}/patent/${patent_ids.join(',')}/favorite-status`,
        method: 'GET',
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}
/**
 * 复制文件夹
 */
export function copyFolderApi({ folder_id, parent_folder, to_space, copy_field_comment_request }) {
    return defPsHttp({
        url: `${workspaceApiUrlPrefix}/folder/${folder_id}/copy-folder`,
        method: 'POST',
        data: {
            parent_folder,
            to_space,
            copy_field_comment_request,
        },
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}
/**
 * 更新folder访问时间
 * @param {string} param.folder_id 文件夹标识
 */
export function accessTsFolderApi({ folder_id }) {
    return defPsHttp({
        url: `${workspaceApiUrlPrefix}/folder/${folder_id}/access`,
        method: 'POST',
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}
/**
 * 获取单个folder信息
 */
export function getFolderApi({ space_id, folder_id, }) {
    return defPsHttp({
        url: `${workspaceApiUrlPrefix}/space/${space_id}/folder/${folder_id}`,
        method: 'GET',
        transformCode: true,
    }).then(({ data }) => {
        return data.data;
    });
}
/**
 * 获取同步同族开关
 */
export function getSyncFieldValueApi({ folder_id }) {
    return defPsHttp({
        url: `${workspaceApiUrlPrefix}/folder/${folder_id}/sync-field-value`,
        method: 'GET',
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}
/**
 * 设置同步同族开关
 */
export function setSyncFieldValueApi({ folder_id, sync_field_value = false, family_expand_buz_type = [] }) {
    return defPsHttp({
        url: `${workspaceApiUrlPrefix}/folder/${folder_id}/sync-field-value`,
        method: 'PUT',
        data: {
            sync_field_value,
            family_expand_buz_type,
        },
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}
/**
 * 获取同族专利数量
 */
export function getFolderFamilyExpansionCountApi({ space_id, folder_id, family_type, patent_ids, select_mode, refiner, range_from, range_to, sort, }) {
    return defPsHttp({
        url: `${workspaceApiUrlPrefix}/folder/${folder_id}/family-expansion-count`,
        method: 'POST',
        transformCode: true,
        data: {
            space_id,
            folder_id,
            family_type,
            patent_ids,
            select_mode,
            refiner,
            start: range_from,
            end: range_to,
            sort,
        },
    }).then(({ data }) => {
        return data.data || {};
    });
}
/**
 * 获取权限自定义字段等组合数据 （patent-view使用）
 */
export function getWorkspaceInfoApi({ space_id, folder_id, patent_id, is_load_comment, view_type }, cache = false) {
    const url = `${workspaceApiUrlPrefix}/${space_id}/folder/${folder_id}/patent/${patent_id}/workspace-info`;
    return defPsHttp({
        url,
        method: 'POST',
        data: {
            patent_id,
            folder_id,
            is_load_comment,
            view_type,
        },
        transformCode: true,
        uuid: url,
        cache,
    });
}
/**
 * 获取patentCount
 */
export function getFolderListCountApi(source) {
    const url = `${workspaceApiUrlPrefix}/space/bi-workspace-patent-count`;
    return defPsHttp({
        url,
        method: 'POST',
        data: {
            source,
        },
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}
/**
 * 查询最近的Folder
 */
export function getRecentFoldersApi() {
    return defPsHttp({
        url: `${workspaceApiUrlPrefix}/all-recent-folders`,
        method: 'GET',
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}
/**
 * 搜索folder
 * @param {*} folder_search_name
 * @returns
 */
export function searchFolderApi(folder_search_name) {
    return defPsHttp({
        url: `${workspaceApiUrlPrefix}/folder/big-search-folder`,
        method: 'POST',
        data: {
            folder_search_name,
        },
        transformCode: true,
    }).then(({ data }) => {
        return data.data || [];
    });
}
/**
 * 新设置同步同族开关和分组模式
 */
export function setSyncFamilyCollapseApi({ folder_id, collapse, family_expand_buz_type = [], family_label_run_folder_switch, family_label_switch }) {
    return defPsHttp({
        url: `${workspaceApiUrlPrefix}/folder/${folder_id}/family-collapse`,
        method: 'PUT',
        data: {
            collapse,
            family_expand_buz_type,
            family_label_run_folder_switch,
            family_label_switch,
        },
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}
/**
 * 保存单条专利到文件夹
 * @param {*} space_id
 * @param {*} folder_id
 * */
export function putSavePatentsApi({ space_id, folder_id, patent_ids, source_type = 'workspace', patent_count = 1, auto = false, type = 'PATENT', }) {
    return defPsHttp({
        url: `${workspaceApiUrlPrefix}/space/${space_id}/folder/${folder_id}/patents/v2`,
        method: 'PUT',
        data: {
            patent_ids,
            source_type,
            patent_count,
            auto,
            type,
        },
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}
/**
 *  当前专利未保存到文件夹的同族列表
 */
export function postMoreFamilyListApi(params) {
    return defPsHttp({
        url: `${workspaceApiUrlPrefix}/more-family-list`,
        method: 'POST',
        data: {
            ...params,
        },
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}
/**
 * 当前专利已经保存到文件夹的同族列表
 */
export function postHitFamilyListApi(params) {
    return defPsHttp({
        url: `${workspaceApiUrlPrefix}/hit-family-list`,
        method: 'POST',
        data: {
            ...params,
        },
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}
